import { render, staticRenderFns } from "./MatterDecisionAdjustmentsList.vue?vue&type=template&id=8b1f2c28&"
import script from "./MatterDecisionAdjustmentsList.vue?vue&type=script&lang=js&"
export * from "./MatterDecisionAdjustmentsList.vue?vue&type=script&lang=js&"
import style0 from "./MatterDecisionAdjustmentsList.vue?vue&type=style&index=0&id=8b1f2c28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports